// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comparison-mode-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 24px;
  cursor: pointer;
  user-select: none;
}

.comparison-mode-row:hover {
  background: var(--color-brand-hover2, #f9e2d6);
}

.comparison-item-list {
  max-height: 220px;
  overflow-y: auto;
}

.comparison-item-list::-webkit-scrollbar {
  width: 4px;
}

.comparison-item-list::-webkit-scrollbar-thumb {
  background-color: var(--surface-disabled);
  border-radius: 2px;
}

.comparison-item-list::-webkit-scrollbar-track {
  background-color: transparent;
}

.comparison-item-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 24px;
  border: none;
  margin-bottom: 10px;
  text-align: left;
}

.comparison-item-flag {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
}

.comparison-item-flag svg {
  width: 16px;
  height: 16px;
}

.comparison-item-symbol {
  flex: 1;
  min-width: 0;
}

.comparison-add-section {
  padding: 16px;
  border-top: 1px solid var(--border-tertiary);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.comparison-add-title {
  font-weight: 700;
}

.comparison-add-row {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  z-index: 10;
}
.comparison-add-type {
  width: 120px;
}
.comparison-add-index {
  flex: 1;
}
.comparison-limit-message {
  padding: 12px 16px;
  color: var(--text-label);
  text-align: center;
}

.comparison-search-input {
  flex: 1;
  min-width: 0;
  padding: 8px 12px;
  border: 1px solid var(--border-tertiary);
  border-radius: 4px;
  font-size: 14px;
  background: var(--surface-primary);
  color: var(--text-primary);
  outline: none;
}

.comparison-search-input:focus {
  border-color: var(--color-brand);
}

.comparison-search-input::placeholder {
  color: var(--text-label);
}

.comparison-search-results {
  border: 1px solid var(--border-tertiary);
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  background: var(--surface-primary);
}

.comparison-search-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid var(--border-tertiary);
  transition: background 0.12s;
}

.comparison-search-item:last-child {
  border-bottom: none;
}

.comparison-search-item:hover {
  background: var(--tab-filter-off-surface2, #f9e2d6);
}

.comparison-search-item-symbol {
  font-weight: 600;
  font-size: 14px;
  min-width: 50px;
}

.comparison-search-item-name {
  flex: 1;
  font-size: 13px;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.comparison-no-results {
  padding: 12px;
  text-align: center;
  color: var(--text-label);
}

.comparison-stock-search {
  position: relative;
  flex: 1;
  min-width: 0;
}

.comparison-stock-search-input-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  border: 1px solid var(--border-tertiary);
  border-radius: 4px;
  background: var(--surface-primary);
  height: 36px;
}

.comparison-stock-search-input-wrap:focus-within {
  border-color: var(--color-brand);
}

/* Make dropdown position relative to .comparison-stock-search, not .input-box */
.comparison-stock-search .input-box {
  position: static;
}

.comparison-stock-search .input-box-dropdown {
  top: calc(100% + 4px);
  left: -128px; /* 120px selector + 8px gap → full add-row width */
  right: 0;
  width: auto;
}

.comparison-stock-search-icon {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  opacity: 0.5;
}

.comparison-stock-search .comparison-search-input {
  border: none;
  padding: 0;
  height: auto;
  flex: 1;
  min-width: 0;
}

.comparison-stock-search .comparison-search-input:focus {
  border-color: transparent;
}

.comparison-search-clear {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-label);
  font-size: 14px;
  padding: 0 2px;
  line-height: 1;
  flex-shrink: 0;
}

.comparison-stock-search .comparison-search-results {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 300;
  max-height: 240px;
}

.comparison-search-item-flag {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.comparison-popup {
  overflow: visible;
}

.comparison-popup .select-dropdown-label {
  text-align: left;
}

.index-picker {
  position: relative;
  flex: 1;
  min-width: 0;
}

.index-picker-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  height: 40px;
  padding: 0 8px;
  border: 1px solid var(--input-border);
  border-radius: 4px;
  background: var(--surface-tertiary);
  color: var(--text-primary);
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  outline: none;
  transition: background 0.12s;
}
.index-picker-menu::-webkit-scrollbar {
  width: 4px;
}

.index-picker-menu::-webkit-scrollbar-thumb {
  background-color: var(--surface-disabled);
  border-radius: 2px;
}

.index-picker-menu::-webkit-scrollbar-track {
  background-color: transparent;
}

.index-picker-trigger:hover {
  background: var(--tab-filter-off-surface2, #f9e2d6);
}

.index-picker-selected-symbol {
  flex: 1;
  min-width: 0;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
}

.index-picker-placeholder {
  flex: 1;
  color: var(--text-label);
  text-align: left;
}

.index-picker-arrow {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.index-picker-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: -128px; /* 120px selector + 8px gap → full add-row width */
  right: 0;
  z-index: 300;
  background: var(--surface-primary);
  border: 1px solid var(--border-tertiary);
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  max-height: 220px;
  overflow-y: auto;
  padding: 4px 0;
  width: auto;
}

.index-picker-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  cursor: pointer;
}

.index-picker-item:hover {
  background: var(--tab-filter-off-surface2, #f9e2d6);
}

.index-picker-item--active {
  color: var(--color-brand);
}

.index-picker-item-symbol {
  font-weight: 600;
  min-width: 42px;
}

.index-picker-item-name {
  flex: 1;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@container (max-width: 600px) {
  .comparison-popup {
    width: 100%;
  }

  .comparison-add-row {
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/AdvanceChartWidget/components/settings/ComparisonSettings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,OAAO;AACT;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,+CAA+C;EAC/C,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA,gFAAgF;AAChF;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY,EAAE,kDAAkD;EAChE,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,OAAO;EACP,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,kBAAkB;EAClB,mCAAmC;EACnC,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,4BAA4B;AAC9B;AACA;EACE,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY,EAAE,kDAAkD;EAChE,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".comparison-mode-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 24px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.comparison-mode-row:hover {\n  background: var(--color-brand-hover2, #f9e2d6);\n}\n\n.comparison-item-list {\n  max-height: 220px;\n  overflow-y: auto;\n}\n\n.comparison-item-list::-webkit-scrollbar {\n  width: 4px;\n}\n\n.comparison-item-list::-webkit-scrollbar-thumb {\n  background-color: var(--surface-disabled);\n  border-radius: 2px;\n}\n\n.comparison-item-list::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n.comparison-item-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 24px;\n  border: none;\n  margin-bottom: 10px;\n  text-align: left;\n}\n\n.comparison-item-flag {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n}\n\n.comparison-item-flag svg {\n  width: 16px;\n  height: 16px;\n}\n\n.comparison-item-symbol {\n  flex: 1;\n  min-width: 0;\n}\n\n.comparison-add-section {\n  padding: 16px;\n  border-top: 1px solid var(--border-tertiary);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.comparison-add-title {\n  font-weight: 700;\n}\n\n.comparison-add-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n  z-index: 10;\n}\n.comparison-add-type {\n  width: 120px;\n}\n.comparison-add-index {\n  flex: 1;\n}\n.comparison-limit-message {\n  padding: 12px 16px;\n  color: var(--text-label);\n  text-align: center;\n}\n\n.comparison-search-input {\n  flex: 1;\n  min-width: 0;\n  padding: 8px 12px;\n  border: 1px solid var(--border-tertiary);\n  border-radius: 4px;\n  font-size: 14px;\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  outline: none;\n}\n\n.comparison-search-input:focus {\n  border-color: var(--color-brand);\n}\n\n.comparison-search-input::placeholder {\n  color: var(--text-label);\n}\n\n.comparison-search-results {\n  border: 1px solid var(--border-tertiary);\n  border-radius: 4px;\n  max-height: 200px;\n  overflow-y: auto;\n  background: var(--surface-primary);\n}\n\n.comparison-search-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  cursor: pointer;\n  border-bottom: 1px solid var(--border-tertiary);\n  transition: background 0.12s;\n}\n\n.comparison-search-item:last-child {\n  border-bottom: none;\n}\n\n.comparison-search-item:hover {\n  background: var(--tab-filter-off-surface2, #f9e2d6);\n}\n\n.comparison-search-item-symbol {\n  font-weight: 600;\n  font-size: 14px;\n  min-width: 50px;\n}\n\n.comparison-search-item-name {\n  flex: 1;\n  font-size: 13px;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.comparison-no-results {\n  padding: 12px;\n  text-align: center;\n  color: var(--text-label);\n}\n\n.comparison-stock-search {\n  position: relative;\n  flex: 1;\n  min-width: 0;\n}\n\n.comparison-stock-search-input-wrap {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0 10px;\n  border: 1px solid var(--border-tertiary);\n  border-radius: 4px;\n  background: var(--surface-primary);\n  height: 36px;\n}\n\n.comparison-stock-search-input-wrap:focus-within {\n  border-color: var(--color-brand);\n}\n\n/* Make dropdown position relative to .comparison-stock-search, not .input-box */\n.comparison-stock-search .input-box {\n  position: static;\n}\n\n.comparison-stock-search .input-box-dropdown {\n  top: calc(100% + 4px);\n  left: -128px; /* 120px selector + 8px gap → full add-row width */\n  right: 0;\n  width: auto;\n}\n\n.comparison-stock-search-icon {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n  opacity: 0.5;\n}\n\n.comparison-stock-search .comparison-search-input {\n  border: none;\n  padding: 0;\n  height: auto;\n  flex: 1;\n  min-width: 0;\n}\n\n.comparison-stock-search .comparison-search-input:focus {\n  border-color: transparent;\n}\n\n.comparison-search-clear {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--text-label);\n  font-size: 14px;\n  padding: 0 2px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.comparison-stock-search .comparison-search-results {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  z-index: 300;\n  max-height: 240px;\n}\n\n.comparison-search-item-flag {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.comparison-popup {\n  overflow: visible;\n}\n\n.comparison-popup .select-dropdown-label {\n  text-align: left;\n}\n\n.index-picker {\n  position: relative;\n  flex: 1;\n  min-width: 0;\n}\n\n.index-picker-trigger {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  height: 40px;\n  padding: 0 8px;\n  border: 1px solid var(--input-border);\n  border-radius: 4px;\n  background: var(--surface-tertiary);\n  color: var(--text-primary);\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  outline: none;\n  transition: background 0.12s;\n}\n.index-picker-menu::-webkit-scrollbar {\n  width: 4px;\n}\n\n.index-picker-menu::-webkit-scrollbar-thumb {\n  background-color: var(--surface-disabled);\n  border-radius: 2px;\n}\n\n.index-picker-menu::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n.index-picker-trigger:hover {\n  background: var(--tab-filter-off-surface2, #f9e2d6);\n}\n\n.index-picker-selected-symbol {\n  flex: 1;\n  min-width: 0;\n  text-align: left;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.index-picker-placeholder {\n  flex: 1;\n  color: var(--text-label);\n  text-align: left;\n}\n\n.index-picker-arrow {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.index-picker-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: -128px; /* 120px selector + 8px gap → full add-row width */\n  right: 0;\n  z-index: 300;\n  background: var(--surface-primary);\n  border: 1px solid var(--border-tertiary);\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n  max-height: 220px;\n  overflow-y: auto;\n  padding: 4px 0;\n  width: auto;\n}\n\n.index-picker-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.index-picker-item:hover {\n  background: var(--tab-filter-off-surface2, #f9e2d6);\n}\n\n.index-picker-item--active {\n  color: var(--color-brand);\n}\n\n.index-picker-item-symbol {\n  font-weight: 600;\n  min-width: 42px;\n}\n\n.index-picker-item-name {\n  flex: 1;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@container (max-width: 600px) {\n  .comparison-popup {\n    width: 100%;\n  }\n\n  .comparison-add-row {\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
